export default __webpack_public_path__ + "static/media/christmas-song.8f764a37.mp3";